import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { site, socials } from '../content';
import { scrollToTarget } from '../hooks/useSmoothScroll';
import { FitText } from './FitText';
import { Reveal, SplitChars } from './Reveal';

export function Contact() {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(site.email);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      window.location.href = `mailto:${site.email}`;
    }
  };

  return (
    <footer id="contact" className="contact">
      <div className="wrap">
        <div className="section-head mono">
          <span>(05)</span>
          <span>Contact</span>
        </div>

        <h2 className="contact__title">
          <Reveal>Have an idea,</Reveal>
          <Reveal delay={0.08}>a cause, or</Reveal>
          <Reveal delay={0.16}>
            a <span className="serif">poem?</span>
          </Reveal>
        </h2>

        <div className="contact__row">
          <a
            className="contact__email u-link"
            href={`mailto:${site.email}?subject=Hello%20Ian`}
            data-cursor="Write"
          >
            {site.email}
          </a>
          <button className="contact__copy mono" onClick={copy} data-cursor="Copy">
            <AnimatePresence mode="wait" initial={false}>
              <motion.span
                key={copied ? 'copied' : 'copy'}
                initial={{ y: 8, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: -8, opacity: 0 }}
                transition={{ duration: 0.2 }}
              >
                {copied ? 'Copied ✓' : 'Copy email'}
              </motion.span>
            </AnimatePresence>
          </button>
        </div>

        <div className="contact__links mono">
          {socials.map((s) => (
            <a key={s.label} className="u-link" href={s.href} target="_blank" rel="noopener noreferrer">
              {s.label} ↗
            </a>
          ))}
        </div>
      </div>

      <div className="contact__bottom wrap mono">
        <span>© {new Date().getFullYear()} {site.studio}</span>
        <span className="contact__motto">{site.motto}</span>
        <span className="contact__greent keep-case">Stay greent.</span>
        <button className="u-link" onClick={() => scrollToTarget(0)}>
          Back to top ↑
        </button>
      </div>

      <FitText className="contact__wordmark wrap" as="p">
        <SplitChars text="Studio" stagger={0.06} />
      </FitText>
    </footer>
  );
}
